// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex !important;
}

.justify-center {
  justify-content: center !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

.justify-space-around {
  justify-content: space-around !important;
}

.justify-space-evenly {
  justify-content: space-evenly !important;
}

.justify-end {
  justify-content: flex-end !important;
}

.align-center {
  align-items: center !important;
}

.align-space-between {
  align-items: space-between !important;
}

.align-end {
  align-items: flex-end !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.display-block {
  display: block !important;
}

.display-inline-block {
  display: inline-block !important;
}

.display-none {
  display: none !important;
}

.float-right {
  float: right !important;
}

.float-left {
  float: left !important;
}

.center-text {
  text-align: center !important;
}

.start-text {
  text-align: start !important;
}

.end-text {
  text-align: end !important;
}

.break-word {
  word-break: break-all !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-hidden-x {
  overflow-x: hidden !important;
}

.overflow-hidden-y {
  overflow-y: hidden !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-scroll-x {
  overflow-x: scroll !important;
}

.overflow-scroll-y {
  overflow-y: scroll !important;
}

.overflow-auto-x {
  overflow-x: auto !important;
}

.overflow-auto-y {
  overflow-y: auto !important;
}

.align-middle {
  vertical-align: middle !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.text-decoration {
  text-decoration: none !important;
  color: unset !important;
}

a {
  text-decoration: none;
  color: inherit;
}

.visibility-hidden {
  visibility: hidden !important;
}

.text-transform-capitalize {
  text-transform: capitalize !important;
}

.text-underline {
  text-decoration: underline !important;
}

.z-index-99 {
  z-index: 99 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/display.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,gCAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAGA;EACE,qCAAA;AAAF;;AAGA;EACE,qCAAA;AAAF;;AAGA;EACE,sBAAA;AAAF","sourcesContent":[".flex {\n  display: flex !important;\n}\n\n.justify-center {\n  justify-content: center !important;\n}\n\n.justify-space-between {\n  justify-content: space-between !important;\n}\n\n.justify-space-around {\n  justify-content: space-around !important;\n}\n\n.justify-space-evenly {\n  justify-content: space-evenly !important;\n}\n\n.justify-end {\n  justify-content: flex-end !important;\n}\n\n.align-center {\n  align-items: center !important;\n}\n\n.align-space-between {\n  align-items: space-between !important;\n}\n\n.align-end {\n  align-items: flex-end !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.display-block {\n  display: block !important;\n}\n\n.display-inline-block {\n  display: inline-block !important;\n}\n\n.display-none {\n  display: none !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-left {\n  float: left !important;\n}\n\n.center-text {\n  text-align: center !important;\n}\n\n.start-text {\n  text-align: start !important;\n}\n\n.end-text {\n  text-align: end !important;\n}\n\n.break-word {\n  word-break: break-all !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-hidden-x {\n  overflow-x: hidden !important;\n}\n\n.overflow-hidden-y {\n  overflow-y: hidden !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-scroll-x {\n  overflow-x: scroll !important;\n}\n\n.overflow-scroll-y {\n  overflow-y: scroll !important;\n}\n\n.overflow-auto-x {\n  overflow-x: auto !important;\n}\n\n.overflow-auto-y {\n  overflow-y: auto !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.text-decoration {\n  text-decoration: none !important;\n  color: unset !important;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.visibility-hidden {\n  visibility: hidden !important;\n}\n\n\n.text-transform-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-underline {\n  text-decoration: underline !important;\n}\n\n.z-index-99{\n  z-index:99 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
